/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letters within a word are separated by a single space, and words are separated by a forward slash with spaces around it ( / ).`)
};

const es_mc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las letras dentro de una palabra se separan por un único espacio, y las palabras se separan por una barra diagonal con espacios alrededor ( / ).`)
};

const de_mc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buchstaben innerhalb eines Wortes werden durch ein einzelnes Leerzeichen getrennt, und Wörter werden durch einen Schrägstrich mit Leerzeichen davor und danach getrennt ( / ).`)
};

const nl_mc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letters binnen een woord worden gescheiden door een spatie, en woorden worden gescheiden door een schuine streep met spaties eromheen ( / ).`)
};

const fr_mc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les lettres dans un mot sont séparées par un seul espace, et les mots sont séparés par une barre oblique avec des espaces autour ( / ).`)
};

const it_mc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le lettere all'interno di una parola sono separate da uno spazio singolo, e le parole sono separate da una barra in avanti con spazi attorno ( / ).`)
};

const pt_br2_mc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letras dentro de uma palavra são separadas por um espaço único, e palavras são separadas por uma barra com espaços ao redor dela ( / ).`)
};

const pt_mc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Letras dentro de uma palavra são separadas por um único espaço, e palavras são separadas por uma barra com espaços ao redor ( / ).`)
};

const ja_mc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`単語内の文字は1つのスペースで分離され、単語は両側にスペースを含むスラッシュで分離されます（ / ）。`)
};

const zh_mc_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`同一个单词内的字母之间用一个空格分隔，单词之间则用一个前后带空格的斜杠（ / ）分隔。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mc_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mc_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mc_faq1_a", locale)
	if (locale === "en") return en_mc_faq1_a(inputs)
	if (locale === "es") return es_mc_faq1_a(inputs)
	if (locale === "de") return de_mc_faq1_a(inputs)
	if (locale === "nl") return nl_mc_faq1_a(inputs)
	if (locale === "fr") return fr_mc_faq1_a(inputs)
	if (locale === "it") return it_mc_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_mc_faq1_a(inputs)
	if (locale === "pt") return pt_mc_faq1_a(inputs)
	if (locale === "ja") return ja_mc_faq1_a(inputs)
	return zh_mc_faq1_a(inputs)
};